exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-wrapper .accordion-container[data-v-bdd394bc] {\n  padding: 16px;\n}\n.modal-wrapper .accordion-wrapper[data-v-bdd394bc] {\n  height: 480px;\n  padding: 8px;\n  overflow: auto;\n}\n.modal-wrapper .top-description[data-v-bdd394bc] {\n  margin-bottom: 16px;\n  text-align: left;\n  font-size: 14px;\n}\n.modal-wrapper .card-header-title[data-v-bdd394bc] {\n  font-size: 12px;\n}\n.modal-wrapper .card-content .content[data-v-bdd394bc] {\n  text-align: left;\n  font-size: 12px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bdd394bc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/organisms/modals/ModalHowToUseParts.vue
// module id = 4lWF
// module chunks = 3